<template>
  <div class="forestMsgPage">
    <van-cell-group class="forestInput" v-if="this.baseMain != ''">
      <van-field
        v-model="baseData.xiaoBan"
        readonly
        :label="$t('oldTree.xiaoBanTitle') + '：'"
      />
      <van-field
        v-model="baseData.diLei"
        readonly
        :label="$t('oldTree.dileiTit') + '：'"
      />
      <van-field
        v-model="baseData.senLinLb"
        readonly
        :label="$t('oldTree.senLinLb') + '：'"
      />
      <van-field
        v-model="baseData.gchengLb"
        readonly
        :label="$t('oldTree.gchengLb') + '：'"
      />
      <van-field
        v-model="baseData.lzName"
        readonly
        :label="$t('common.linZhang') + '：'"
      />
      <van-field
        v-model="baseData.hlyName"
        readonly
        :label="$t('common.ranger') + '：'"
      />
    </van-cell-group>
    <div class="nonePage" v-if="this.baseMain == ''">
      <img :src="nonePng" alt />
      <p>{{$t('common.noDataTip')}}</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "affiliation",
  data() {
    return {
      objId: "",
      baseData: {},
      baseMain: "false",
      nonePng: nonePng,
      geometry: "",
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    // this.ordTreeId= this.$route.query.gridLevel;
    this.$nextTick(function () {
      // this.objId = this.dataInfo.id;
      this.objId = this.$route.query.commonId;
      if (this.objId == undefined) {
        this.objId = this.dataInfo.id;
      }
      this.initPage();
    });
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal.oldTree
        .oldTreeMsg({
          objid: _this.objId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.geometry = res.data.geometry;
            _this.geoGuShu();
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    geoGuShu() {
      let _this = this;
      _this.$api.universal.oldTree
        .geoGuShuMsg({
          geometry: _this.geometry,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null) {
              _this.baseMain = "";
            } else {
              _this.baseData = Object.assign({}, _this.baseData, res.data);
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.objId = this.dataInfo.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.forestMsgPage {
  width: 100%;
  height: 100%;
  overflow: scroll-y;

  .forestInput {
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>